/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrServiceUser } from './irrServiceUser';
import { IrrCloudProvider } from './irrCloudProvider';


/**
 * IRR SaaS Config Cloud Provider Section
 */
export interface IrrSaasCloudProvider { 
    provider?: IrrCloudProvider;
    /**
     * deployment region
     */
    region?: string;
    /**
     * List of AZs for IRR.
     */
    availabilityZones?: Array<string>;
    serviceUsers?: Array<IrrServiceUser>;
}
export namespace IrrSaasCloudProvider {
}


